"use client"

import { motion } from "framer-motion"
import type { ReactNode } from "react"

type ScrollRevealProps = {
    children: ReactNode
    className?: string
    delay?: number
}

/**
 * Fades content up the first time it scrolls into view.
 *
 * Exists so a server component can keep its markup on the server and hand it
 * to framer-motion as children — inlining `motion.div` would drag the whole
 * subtree into the client bundle.
 */
export function ScrollReveal({
    children,
    className,
    delay = 0,
}: ScrollRevealProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay }}
            viewport={{ once: true }}
            className={className}
        >
            {children}
        </motion.div>
    )
}
